<template>
  <div class="content">
    <div class="error-box">
      <div>
        <img class="oopsImg" src="@/assets/image/public/oops.svg" />
      </div>
      <div>
        <div class="message-box">
          <img class="pencilImg" src="@/assets/image/public/pencil.svg" />
          <h1 class="main-error-message">{{ mainErrorMessage }}</h1>
          <h2 class="sub-error-message">
            此頁面可能發生錯誤或已經下架，您可以：
          </h2>
          <ul>
            <li>稍後再試一次</li>
            <li>
              前往<router-link :to="{ name: 'Home' }">首頁</router-link
              >，瀏覽其他頁面
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.pageName,
    };
  },
  data() {
    return {
      pageName: 'Opps 發生了錯誤!',
      mainErrorMessage: '',
    };
  },
  mounted() {
    // 暫無設計404以外的錯誤 之後有的話可以擴充
    // var errorMessage = this.$route.params.errorCode;//暫無設計404以外的錯誤
    // if(errorCode == 404 || errorCode == undefined){
    this.mainErrorMessage = '很抱歉，我們找不到該頁面。';
    // }
  },
};
</script>

<style src="@/assets/css/error.css" scoped></style>
